import PropTypes from 'prop-types';
import CameraPropTypes from './camera';

export default PropTypes.shape({
  isMultiCam: PropTypes.bool,
  numCams: PropTypes.number,
  cameras: PropTypes.arrayOf(CameraPropTypes).isRequired,
  initialCameras: PropTypes.arrayOf(CameraPropTypes).isRequired,
  primaryCam: CameraPropTypes,
  activeView: PropTypes.oneOf(['SINGLE', 'MULTI']).isRequired,
});
